import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const TEXT_2_JUSTIFY = {
  left: 'start',
  center: 'center',
  right: 'end'
};

const ImageBottomSheetHTML: FC = () => {
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);

  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );
  const radius = useSelector((state: RootState) => state.imageUpload.radius);
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);
  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const btnURL = getFontURL(btnFontFamily?.button);
  // const titleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.title}`;
  // const subTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.sub_title}`;
  // const btnURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.button}`;
  const closeImageUrl = 'https://i.ibb.co/BTbz6mq/xmark.png';
  const style = `
  @font-face {
    font-family: 'title';
    src: url(${titleFontURL});
  }
  @font-face {
    font-family: 'subTitle';
    src: url(${subTitleFontURL});
  }
  @font-face {
    font-family: 'btn';
    src: url(${btnURL});
  }
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;
      
      position: relative;
      background: none;
      overflow: hidden;
    }
    .background {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      background: rgba(0, 0, 0,${displayValue});
    }
    .modal_wrapper {
      ${
        bgImage?.background || bgImage?.background !== ''
          ? `background-image: url(${bgImage?.background});`
          : 'background: rgba(0, 0, 0, 0.8);'
      };
      width: 100%;
      height: 260px;
      padding: 0px 10% 0px 10%;

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;      

      position: absolute;
      bottom: 0;

      overflow: hidden;
      border-radius: ${radius?.background}px ${radius?.background}px 0 0;

      display: flex;
      flex-direction: column;      
    }

    .close_btn {
      width: 100%;
      display: flex;
      justify-content: end;
      margin-top:16px;
    }
    .close_btn button {
      width: 24px;
      height: 24px;
      
      background-image: url(${closeImageUrl});
      background-repeat: no-repeat;
      background-size: 24px;
      background-position: center;

      font-size: 0;
      border: none;
      background-color: transparent;
    }

    .contents_box {
      height: 144px;
      margin-top: 8px;
      margin-bottom:30px;
      display: flex;
      flex-direction: column;
      
    }
    .contents_box .title {
      width: 100%;
      height: 64px;

      display: flex;
      align-items: center;
      justify-content: ${TEXT_2_JUSTIFY[textAlign?.title]};
    }
    .contents_box .title_inner {
      max-height: 56px;
      height: auto;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.title};
      color: ${color?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily.title
          : 'title'
      };
    }

    .contents_box .sub_title {
      width: 100%;
      height: 48px;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;

      text-align: ${textAlign?.sub_title};
      color: ${color?.sub_title};
      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily.sub_title
          : 'subTitle'
      };
    }
    .btn_wrapper {
      margin-bottom: 35px;      
    }
    .btn_wrapper button {
      padding: 10px 16px;
      border: 0;
      
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      font-size: ${btnFontSize?.button}rem;
      font-weight: ${btnFontWeight?.button};
      color: ${btnColor?.button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.button
        )
          ? btnFontFamily?.button
          : 'btn'
      };

      border-radius: ${radius?.button}px;
      background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
    }

		@media screen and (min-width: 608px) and (max-width: 1024px) {
      .modal_wrapper {
        height: 29.065rem;
        padding: 2rem 25% 4rem 25%;
      }
      
      .contents_box {
        margin-top: 1.5rem;
      }
      .contents_box .title {
        height: 6rem;
      }
      .title_inner {
        font-size: ${fontSize?.title + 0.125}rem;
      }
      .contents_box .sub_title {
        height: 4rem;
        -webkit-line-clamp: 4;
      }
    }
  `;

  const html = `
    <div class="root" id="test">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="modal_wrapper">
        <div class="close_btn">
          <button class="close_btn_inner">close</button>
        </div>
        <div class="contents_box" onclick="appboyBridge.logClick('image'); window.location = '${
          deeplink?.background
        }';">          
            <div class="title">
              <div class="title_inner">${changeEnterHTML(text?.title)}</div>
            </div>
            <div class="sub_title">${changeEnterHTML(
              text?.sub_title
            )}</div>          
          </div>
          <div class="btn_wrapper">
            <button class="btn_inner">
              ${btnText?.button}
            </button>
          </div>
      </div>
    </div>
  `;

  let tracking_list = '[';
  for (let i = 0; i < tracking?.button?.length; i++) {
    tracking_list += `['${tracking?.button?.[i]}', '${tracking?.sub_button?.[i]}'],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList(
    'IMAGE BOTTOM SHEET',
    button1,
    button2
  );

  const js = `
  document.addEventListener("DOMContentLoaded", function(){
    let tracking = ${tracking_list};
    let button1 = ${tracking_button_list[0]};
    let button2 = ${tracking_button_list[1]};
    $('.close_btn_inner').click(function() {
      appboyBridge.logClick(tracking[0][1]);
      try {
        if (button1[1].indexOf(0) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[1].indexOf(0) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      appboyBridge.closeMessage();
    });
    $('.btn_inner').click(function() {
      appboyBridge.logClick(tracking[0][0]);
      try {
        if (button1[0].indexOf(0) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[0].indexOf(0) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = '${deeplink?.background}';
    });
  });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />

        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <style dangerouslySetInnerHTML={{ __html: style }} />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};
export default ImageBottomSheetHTML;
